<template>
  <div>
    <add-heading v-if="viewmore" title="Social Profiles"  v-on:add="viewmoreCliked" label="more" :stepped="false" />
    <div class="columns" v-if="profiles.length > 0">
      <div class="column" :class="cssClass" v-for="p in profiles.slice(0,3)" :key="p.profileName">
        <div class="card card-hover">
          <div class="card-content">
            <a class="is-flex content-center is-flex-column" target="_blank" :href="link(p)">
              <user-image class="is-circle m-b-16" v-if="p.profileName === 'website'" :user="user" size="is-48x48" />
              <img  class="m-b-16 is-circle" v-else width="48" :src="icon(p.profileName)" />
              <strong class="heading">{{label(p.profileName)}}</strong>
              <p class="m-t-8">{{p.profileValue | normalize }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserImage from '@/components/general/user-image'
import AddHeading from '@/components/general/add-heading'
import { profileLabel, profileIcon, profileLink } from '@/helpers/external-profiles'

export default {
  components: { UserImage, AddHeading },
  props: {
    profiles: {
      type: Array,
      required: true
    },
    viewmore: {
      type: Boolean,
      required: false,
      default: false
    },
    user: {
      type: Object,
      required: false
    }
  },
  filters: {
    normalize (value) {
      if (!value) {
        return ''
      }
      return value.replace(/https?:\/\/(www\.)?/g, '')
    }
  },
  computed: {
    cssClass () {
      let column = 'is-12'
      switch (this.profiles.length) {
        case 1:
          column = 'is-12'
          break
        case 2:
          column = 'is-6'
          break
        default:
          column = 'is-4'
      }
      return column
    }
  },
  methods: {
    viewmoreCliked () {
      this.$emit('view')
    },
    label (p) {
      return profileLabel(p)
    },
    icon (p) {
      return profileIcon(p)
    },
    link (p) {
      return profileLink(p)
    }
  }
}
</script>

<style scoped>
  a, a:hover {
    text-decoration: none
  }
  a p {
    color: #111;
  }
  p {
    width: 100%;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/profiles/profile-section-ro.vue